<style lang="scss" src='./SensorOffline.scss' scoped ></style>
<template src="./SensorOffline.html"></template>

<script>
import CommonComponent from '@/components/utils/CommonComponent.vue';

export default {
  name: 'SensorOffline',
  extends: CommonComponent,
  data() {
    return ({
      sensor: null,
    });
  },
  computed: {},

  methods: {},

  beforeCreate() {},

  created() {},
  
  beforeMount() {
    this.setShowMenu(false);
    this.setShowBackground(false);
  },

  mounted() {
    this.sensor = this.$store.state.sensor;
  },
};
</script>
